import { Editor, Transforms, Range, Text } from 'slate';
import { ReactEditor } from 'slate-react';

function splitWordsWithSpaces(text) {
  return text.match(/(\S+\s+|\s+)/g) || [];
}

export function splitTextNodeOnSpace(editor) {
  const { selection } = editor;
  if (!selection || !Range.isCollapsed(selection)) return;

  const [match] = Editor.nodes(editor, {
    match: (n) => Text.isText(n),
    mode: 'lowest',
  });
  if (!match) return;
  const [node, path] = match;
  const { text, data } = node;
  const offset = selection.anchor.offset;

  const beforeText = text.slice(0, offset) + ' ';
  const afterText = text.slice(offset);

  const parts = splitWordsWithSpaces(beforeText);

  const newNodes = parts.map((part) => {
    const rnd = Math.random();
    return {
      ...node,
      text: part,
      data: {
        ...data,
        start: data.start + 0.001 * rnd,
      },
    };
  });
  {
    const rnd = Math.random();
    newNodes.push({
      ...node,
      text: afterText,
      data: {
        ...data,
        start: data.start + 0.001 * rnd,
      },
    });
  }

  const parentPath = path.slice(0, -1);
  const originalIndex = path[path.length - 1];
  const targetIndex = originalIndex + newNodes.length - 1;
  const targetPath = [...parentPath, targetIndex];

  Editor.withoutNormalizing(editor, () => {
    Transforms.removeNodes(editor, { at: path });
    Transforms.insertNodes(editor, newNodes, { at: path });
    Transforms.select(editor, { path: targetPath, offset: 0 });
  });

  ReactEditor.focus(editor);
}
